export const appRedirects = [
  {
    route: "resources/podcasts/:articleId",
    paramKey: "articleId",
    destination: "/podcasts/:articleId",
  },
  {
    route: "resources/bright-tv/:articleId",
    paramKey: "articleId",
    destination: "/bright-tv/:articleId",
  },
  {
    route: "resources/audio-and-video/:articleId",
    paramKey: "articleId",
    destination: "/audio-and-video/:articleId",
  },
  {
    route: "resources/articles/:articleId",
    paramKey: "articleId",
    destination: "/articles/:articleId",
  },
  {
    route: "resources/newsletters/:articleId",
    paramKey: "articleId",
    destination: "/newsletters/:articleId",
  },
  {
    route: "account/account-security",
    destination: "/account-security",
  },
  {
    route: "contact-us",
    destination: "/support",
  },
  {
    route: "mobile-contact-us",
    destination: "/mobile-support",
  },
];
